import { useState } from 'react';
import TextInput from './TextInput';
import TextInputWithInlineLabel from './TextInputWithInlineLabel.jsx';
import MagnifyingGlassIcon from './icons/MagnifyingGlassIcon.jsx';
import { useUnplashQuery } from '../lib/Queries';
import Loading from './Loading';
import { useDebounce } from '@uidotdev/usehooks';

const UnsplashPicker = ({ onChange, value }) => {
    const [search, setSearch] = useState('');
    const debouncedSearch = useDebounce(search, 500);
    const { data, isLoading } = useUnplashQuery(
        debouncedSearch || 'background',
    );

    const results = data || [];

    function getUrl(result) {
        return result.urls.full;
    }

    return (
        <div className="flex flex-col h-full">
            <TextInputWithInlineLabel
                onChange={setSearch}
                value={search}
                placeholder="Search Unplash Photos"
                inputClassName="pl-8"
                className="mb-6"
                prefix={
                    <MagnifyingGlassIcon className="w-4 h-4 text-primary-700" />
                }
            />
            <div className="flex-1 grid grid-cols-2 gap-x-4">
                {results.map(result => (
                    <div
                        className={`mb-4 cursor-pointer`}
                        onClick={() => onChange(getUrl(result))}
                    >
                        <img
                            src={result.urls.small}
                            alt={result.description}
                            className={`rounded-lg ${getUrl(result) === value ? 'ring-2 ring-offset-2 ring-primary-700' : ''}`}
                        />
                    </div>
                ))}
                {isLoading && <Loading />}
                {results.length === 0 && !isLoading && <span>No Results</span>}
            </div>
            <div className="text-xs py-2">
                By using images from Unsplash, you agree to their{' '}
                <a href="https://unsplash.com/license" target="_blank">
                    license
                </a>{' '}
                and{' '}
                <a href="https://unsplash.com/terms" target="_blank">
                    Terms of Service
                </a>
            </div>
        </div>
    );
};

export default UnsplashPicker;
